export default function createCompanyServices(companyServices, agentServices) {
  const prods = [];
  if (typeof companyServices !== 'number') {
    companyServices?.forEach((i) => {
      const p = agentServices.find((s) => s.id === i);
      if (p) prods.push(p.name);
    });
  } else {
    prods.push(agentServices.find((s) => s.id === companyServices).name);
  }
  return prods;
}
